import React from "react";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";
import { Button } from "../../UI/Button";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { AddAdminNotificationModal } from "./AddAdminNotificationModal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

export interface IProps {
  reloadSubscriptions: () => Promise<void>;
}

export const AddAdminNotificationButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button
          appearance="primary"
          onClick={openModal}
          isDisabled={!selectedNetworkId}
          iconBefore={<EditorAddIcon label="Add" />}
        >
          Add Email
        </Button>
      </ReadOnlyWrapper>
      <AddAdminNotificationModal {...props} />
    </>
  );
};
